(() => {
  const roots = document.querySelectorAll('[data-zaoud-faq]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const oneOpen = root.dataset.oneOpen === 'true';
    const items = [...root.querySelectorAll('[data-zaoud-faq-item]')];
    if (!items.length) return;

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open || !oneOpen) return;
        items.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  });
})();
